import { render, staticRenderFns } from "./TurmaInformacoes.vue?vue&type=template&id=7eb4aa2d"
import script from "./TurmaInformacoes.vue?vue&type=script&lang=js"
export * from "./TurmaInformacoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports